
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.5 5.7l11.2 28.9c.2.6.8 1 1.4 1L96 37.4c1.5.1 2.1 1.9.9 2.8L73 59.8c-.5.4-.7 1-.5 1.6l7.9 30c.4 1.4-1.2 2.5-2.4 1.8L52 76.4c-.5-.3-1.2-.3-1.7 0L24.1 93.1c-1.2.8-2.8-.3-2.4-1.8l7.9-30c.2-.6 0-1.3-.5-1.6l-24-19.6c-1.1-.9-.5-2.8.9-2.8l30.9-1.7c.6 0 1.2-.4 1.4-1L49.6 5.7c.5-1.4 2.4-1.4 2.9 0z"}})])
          )
        }
      }
    